<div class="notification-icon" #mPopover="m-popover" popoverPosition="bottomRight" [m-popover]="notificationsTmp">
  <ion-icon name="notifications"></ion-icon>
  <span class="badge" *ngIf="unreadNotificationsNumber">{{ unreadNotificationsNumber }}</span>
</div>

<ng-template #notificationsTmp>
  <app-notifications-popover (actionClicked)="onActionClicked()"></app-notifications-popover>
</ng-template>
